import modulesAPI from '../../../api/modules'
import * as errorMessages from '../../../error-messages'

const mapOrder = (order) => {
  switch (order) {
  case 'name':
    return 'name'
  case 'created':
    return 'created_at'
  default:
    return 'name'
  }
}

export default {
  async indexNoPaginate({commit, rootState}) {
    const tenantID = rootState.tenants.current.id
    const resp = await modulesAPI.index({
      tenantID,
      short: true,
      showHidden: true
    })
    const index = resp.data.data

    commit('setComplete', {index, parentID: tenantID})
  },

  async index({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta
    const params = {tenantID, paginate: meta.paginate}

    if (typeof(meta.showHidden) !== 'undefined' && meta.showHidden !== null) {
      params.showHidden = meta.showHidden
    }
    if (typeof(meta.active) !== 'undefined' && meta.active !== null) {
      params.active = meta.active
    }
    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await modulesAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id}) {
    const tenantID = rootState.tenants.current.id
    const resp = await modulesAPI.show({tenantID, moduleID: id})
    const module = resp.data.data
    commit('setCurrent', module)
  },

  async store({commit, state, rootState, dispatch}) {
    const tenantID = rootState.tenants.current.id

    const formData = new FormData()
    formData.append('name', state.forms.store.fields.name)
    formData.append('description', state.forms.store.fields.description)

    // existing image
    if (state.forms.store.fields.imageID) {
      formData.append('image_id', state.forms.store.fields.imageID)

    // new image
    } else if (state.forms.store.fields.image) {
      formData.append('image', state.forms.store.fields.image)
      formData.append('image_name', state.forms.store.fields.imageName)
    }

    // add any media relations
    let mediaData
    if (state.forms.relateMedia.fields.mediaIDs !== null) {
      mediaData = {'media': state.forms.relateMedia.fields.mediaIDs}
    }

    // add any group relations
    let groupData
    if (state.forms.relateGroups.fields.groupIDs !== null) {
      groupData = {'groups': state.forms.relateGroups.fields.groupIDs}
    }

    // add any member relations
    let memberData
    if (state.forms.relateMembers.fields.memberIDs !== null) {
      memberData = {'tenant_users': state.forms.relateMembers.fields.memberIDs}
    }

    let newModule, resp
    let addedRelations = false
    let success = true

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/store/setSaving', true)

    try {
      // update the module
      resp = await modulesAPI.store({tenantID, data: formData})
      newModule = resp.data.data

      // add any media relations
      if (mediaData) {
        await modulesAPI.relateMedia({tenantID, moduleID: newModule.id, data: mediaData})
        addedRelations = true
      }

      // add any group relations
      if (groupData) {
        await modulesAPI.relateGroups({tenantID, moduleID: newModule.id, data: groupData})
        addedRelations = true
      }

      // add any member relations
      if (memberData) {
        await modulesAPI.relateMembers({tenantID, moduleID: newModule.id, data: memberData})
        addedRelations = true
      }

      // update the resource if we added any relations
      if (addedRelations) {
        resp = await modulesAPI.show({tenantID, moduleID: newModule.id})
        newModule = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          if (errors.image) {
            for (let i=0; i< errors.image.length; i++) {
              if (errors.image[i].includes('required')) {
                errors.image[i] = errorMessages.IMAGE_REQUIRED
              }
            }
            commit('forms/store/setFieldErrors', {
              field: 'other',
              errors: errors.image
            })
          }
          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSuccess', success)
    commit('forms/store/setSaving', false)

    if (success) {
      commit('setCurrent', newModule)
      dispatch('index', state._defaultView)
    }
  },

  async update({commit, state, rootState, dispatch}, {moduleID}) {
    const tenantID = rootState.tenants.current.id
    const data = new FormData()

    if (state.forms.update.fields.active !== null) {
      data.append('is_active', state.forms.update.fields.active)
    }

    if (state.forms.update.fields.name) {
      data.append('name', state.forms.update.fields.name)
    }

    if (state.forms.update.fields.description) {
      data.append('description', state.forms.update.fields.description)
    }

    if (state.forms.update.fields.image) {
      data.append('image', state.forms.update.fields.image)
    }

    if (state.forms.update.fields.imageName) {
      data.append('image_name', state.forms.update.fields.imageName)
    }

    // existing image
    if (state.forms.update.fields.imageID) {
      data.append('image_id', state.forms.update.fields.imageID)

    // new image
    } else if (state.forms.update.fields.image) {
      data.append('image', state.forms.update.fields.image)
      data.append('image_name', state.forms.update.fields.imageName)
    }

    // add any media relations
    let mediaData
    if (state.forms.relateMedia.fields.mediaIDs !== null) {
      mediaData = {'media': state.forms.relateMedia.fields.mediaIDs}
    }

    // add any group relations
    let groupData
    if (state.forms.relateGroups.fields.groupIDs !== null) {
      groupData = {'groups': state.forms.relateGroups.fields.groupIDs}
    }

    // add any member relations
    let memberData
    if (state.forms.relateMembers.fields.memberIDs !== null) {
      memberData = {'tenant_users': state.forms.relateMembers.fields.memberIDs}
    }

    let addedRelations = false
    let updatedModule, resp
    let success = true

    commit('forms/update/resetErrors')
    commit('forms/update/resetSuccess')
    commit('forms/update/setSaving', true)

    try {
      // store the module
      resp = await modulesAPI.update({tenantID, moduleID, data})
      updatedModule = resp.data.data

      // add any media relations
      if (mediaData) {
        await modulesAPI.relateMedia({tenantID, moduleID: updatedModule.id, data: mediaData})
        addedRelations = true
      }

      // add any member relations
      if (memberData) {
        await modulesAPI.relateMembers({tenantID, moduleID: updatedModule.id, data: memberData})
        addedRelations = true
      }

      // add any group relations
      if (groupData) {
        await modulesAPI.relateGroups({tenantID, moduleID: updatedModule.id, data: groupData})
        addedRelations = true
      }

      // update the resource if we added any relations
      if (addedRelations) {
        resp = await modulesAPI.show({tenantID, moduleID: updatedModule.id})
        updatedModule = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/update/setErrors', errors)
        }
      }
    }

    commit('forms/update/setSuccess', success)
    commit('forms/update/setSaving', false)

    if (success) {
      commit('upsert', {view: state._defaultView, entity: updatedModule})
      commit('setCurrent', updatedModule)
      dispatch('index', state._defaultView)
    }
  },

  async restore({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const data = { 'is_deleted': false, 'is_restored': true, 'is_active': true }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await modulesAPI.update({tenantID, moduleID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async archive({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await modulesAPI.destroy({tenantID, moduleID: id})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async hide({commit, rootState}, {moduleIDs}) {
    const tenantID = rootState.tenants.current.id
    modulesAPI.hide({tenantID, data: moduleIDs})
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/modules/actions.js